import { render, html } from "lit-html";
import connect from "@escapio/shared/data-store/connect";
import { store, ACTION_SET_FILTER } from "./DataStore";
import * as Board from "../board";
import { track } from "@escapio/portal/tracker/EventTracker";

customElements.define(
	"esc-profile-board-filter",
	class extends connect(HTMLElement, store) {
		update(state, store) {
			const template = html`
				${Object.entries(Board.OPTIONS).map(
					([key, label]) =>
						html`<label class="form-radio">
							<input
								class="form-radio__input"
								type="radio"
								name="board"
								value=${key}
								.checked=${state.filters.board == key}
								@change=${this.onChange}
								?disabled=${!store.boardFilterAvailable(key)}
							/>
							<span class="form-radio__label">${label}</span>
						</label>`,
				)}
			`;
			return render(template, this, { host: this });
		}

		onChange(evt) {
			const { checked, value } = evt.target;
			if (checked) {
				this.dispatchAction(ACTION_SET_FILTER, {
					board: value,
				});

				track(
					"Hotel",
					"Preis Filter",
					`${Board.TRACKING_LABELS[value]}${checked ? "" : " entfernen"}`,
				);
			}
		}
	},
);
